import type { StateCreator } from 'zustand';
import { DEFAULT_STATE } from '../constants';
import type { GuidedDoctorConsultsActions, GuidedDoctorConsultsSliceType } from '../types';

export const resetGuidedDoctorConsult: StateCreator<
  GuidedDoctorConsultsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  GuidedDoctorConsultsActions['resetGuidedDoctorConsult']
> = (set) => {
  return () => {
    set(
      (state) => {
        state.guidedDoctorConsult = DEFAULT_STATE.guidedDoctorConsult;
      },
      false,
      'guidedDoctorConsult/resetGuidedDoctorConsult',
    );
  };
};
